import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import ProductTable from "./ProductTable";
import { Message } from "primereact/message";
import { SplitButton } from "primereact/splitbutton";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getProducts } from "../../store/AsyncMethods/ProductMethod";
import { usePermissions } from "../../permissions/PermissionContext";

export default function ProductMain() {
  const { canOpen } = usePermissions();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.ProductReducer.products);

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);

  // Mock items for the "Bulk Manage" dropdown
  const bulkManageItems = [
    {
      label: 'Bulk Edit',
      icon: 'pi pi-pencil',
    },
    {
      label: 'Bulk Delete',
      icon: 'pi pi-trash',
    }
  ];

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <div>
            <p className="text-sm text-gray-500">Home &gt; Manage Products</p>
        </div>
        <div className="flex items-center gap-2">
          {/* <Button
            label="Product Data"
            className="p-primary-btn"
          /> */}
           {/* <SplitButton 
            label="Bulk Manage"
            model={bulkManageItems}
            className="p-primary-btn"
          /> */}
          {canOpen("/add-product") && (
            <Button
              label="New Product"
              icon="pi pi-plus"
              className="p-primary-btn"
              onClick={() => navigate("/add-product")}
            />
          )}
        </div>
      </div>
      
      <div className="my-4">
        <ProductTable products={products} />
      </div>
    </div>
  );
}